import React from 'react';
import HomeSearchBar from '../components/HomeSearchBar'
import reactRender from '../../../common/js/lib/react-render';


reactRender('#home-search-bar-container', <HomeSearchBar />)
